import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoggerService } from './logger.service';

@Injectable({
  providedIn: 'root'
})
export class PublicapiV1Service {

  constructor(private http: HttpClient, private logger: LoggerService) { }

  prepareDocumentFromToken(clientId, token, grayscale, page) {
    var promise = new Promise((resolve, reject) => {
      this.http.post("api/v1/private/fromclient", { ClientId: clientId, Token: token, GrayScale: grayscale, PageNumber: page }).subscribe({
          next: (data: any) => resolve(data),
          error: (err: Error) => reject(this.logger.logApiError(err, 'requestReplacePage'))
        });
    });
    return promise;
  }

  prepareForClient(document: any = undefined, token: any = undefined, pageModified: any = undefined) {
    var modified = pageModified ? "yes" : "no";
    var promise = new Promise((resolve, reject) => {
      this.http.post("api/v1/private/toclient", { Document: document, Token: token, PageModified: modified }).subscribe(
        {
          next: (data: any) => resolve(data),
          error: (err: Error) => reject(this.logger.logApiError(err, 'requestReplacePage'))
        }
      );
    });
    return promise;
  }

  requestReplacePage(page, token, pageModified, clientPageCount) {
    var modified = pageModified ? "yes" : "no";
    var promise = new Promise((resolve, reject) => {
      this.http.post("api/v1/private/replacepage", { Page: page, Token: token, PageModified: modified, ClientPageCount: clientPageCount }).subscribe(
        {
          next: (data: any) => resolve(data),
          error: (err: Error) => reject(this.logger.logApiError(err, 'requestReplacePage'))
        }
      );
    });
    return promise;
  }

  checkToken(token, clientId) {
    var promise = new Promise((resolve, reject) => {
      this.http.post("api/v1/private/checktoken", { Token: token, ClientId: clientId }).subscribe(
        {
          next: (data: any) => resolve(data),
          error: (err: Error) => reject(this.logger.logApiError(err, 'checkApiToken'))
        }
      );
    });
    return promise;
  }

  getDownloadUrl(token, fileType) {
    var promise = new Promise((resolve, reject) => {
      this.http.get("api/v1/private/downloadurl?token=" + token + "&fileType=" + fileType).subscribe(
        {
          next: (data: any) => resolve(data),
          error: (err: Error) => reject(this.logger.logApiError(err, 'getDownloadUrl'))
        }
      );
    });
    return promise;
  }

  getOCRLangs(lang) {
    var promise = new Promise((resolve, reject) => {
      this.http.get("api/v1/private/getocrlangs?lang=" + lang).subscribe(
        {
          next: (data: any) => resolve(data),
          error: (err: Error) => reject(this.logger.logApiError(err, 'getOCRLangs'))
        }
        );
      });
    return promise;
  }

  deletePage(document, pageIndex) {
    //return this.http.delete("api/v1/private/deletepage", { Document: document, PageIndex: pageIndex }).subscribe(
    //  response => { return response.data; },
    //  response => { return this.logger.logApiError(response, 'deletePage'); });


    //TODO: Preveri http.delete
    //var promise = new Promise((resolve, reject) => {
    //  this.http.delete("api/v1/private/deletepage", { Document: document, PageIndex: pageIndex }).subscribe(
    //      success => {
    //        const data: any = success; // to ignore errors
    //        resolve(data);
    //      },
    //      error => {
    //        reject(this.logger.logApiError(error, 'deletePage'));
    //      }
    //    );
    //  });
    //return promise;    
  }

  initCache(document, token, grayScale) {
    var promise = new Promise((resolve, reject) => {
      return this.http.post("api/v1/private/init-cache", { Document: document, Token: token, GrayScale: grayScale }).subscribe(
        {
          next: (data: any) => resolve(data),
          error: (err: Error) => reject(this.logger.logApiError(err, 'initCache'))
        }
      );
    });
    return promise;  
  }
}
